import { Alert, Button, CardContent, CardHeader, FormControl, InputLabel, OutlinedInput, Stack } from "@mui/material";
import { FormEvent, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import LoginContainer from "../components/login/LoginContainer";
import useRequests from "../hooks/http";
import { Status } from "../enums/status";
import StatusDisplay from "../components/feedback/Status";

export default function Reset() {
  const { post, data, code } = useRequests();
  const [status, setStatus] = useState<any>();
  const [message, setMessage] = useState<any>();

  const [username, setUsername] = useState("");

  const handleSubmit = async (e: FormEvent) => {
    setStatus(Status.LOADING);
    e.preventDefault();
    const response = await post("/auth/password/reset", { username });
    setMessage(data.message);
    setTimeout(() => setStatus(Status.SUCCESS), 2500);
  };

  return (
    <Stack component={"form"} sx={{ flexGrow: 1 }} spacing={2} onSubmit={handleSubmit}>
      <Alert severity="info">Account recovery / password reset</Alert>

      <FormControl fullWidth={true}>
        <InputLabel htmlFor="outlined-basic">Username</InputLabel>
        <OutlinedInput
          id="outlined-basic"
          placeholder="Username"
          label="Username"
          type="email"
          required
          onChange={(e) => setUsername(e.target.value)}
        />
      </FormControl>
      <Button variant="contained" type="submit">
        Submit
      </Button>
      <Button component={Link} to="/">
        Back To Login
      </Button>
    </Stack>
  );
}
